import { styled } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";

const CustomCheckbox = styled(FormControlLabel)(({ checked }) => ({
  "&.MuiFormControlLabel-root": {
    marginBottom: 5,
  },

  "& .MuiFormControlLabel-label": {
    fontWeight: 400,
    fontSize: "16px",
    color: "#000000",
  },
  ".Mui-checked": {
    color: "#5E70CC",
  },
}));
export default CustomCheckbox;
